// extracted by mini-css-extract-plugin
export default {"wrapper":"ConditionalsText_wrapper__1FOfz","title":"ConditionalsText_title__iHJKH","inline":"ConditionalsText_inline__wjODt","text":"ConditionalsText_text__Mk5D0"};